"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTable = styled_components_1.default.table `
  th {
    font-weight: bold;
    padding: 5px;
  }
  tr {
    td {
      padding: 5px;
    }
  }
`;
//# sourceMappingURL=styled-table.js.map